import React, { useState } from 'react';
import { FavIcon as RocketFavIcon } from '@totalsoft/rocket-ui';
import favIcon from 'assets/img/defaultFavIcon.ico';
import { useAuthUserData } from 'hooks';
import { useQuery } from '@apollo/client';
import { LOGO_QUERY } from './Sidebar';
import { convertBase64ToObjectUrl } from 'utils/base64FileConversion';

const FavIcon = () => {
  const [smallLogoSrc, setSmallLogoSrc] = useState(null);
  const { authUser } = useAuthUserData();

  const { loading } = useQuery(LOGO_QUERY, {
    variables: { isSmall: true },
    skip: !authUser?.userId,
    onError: err => console.warn(`Favicon could not be loaded! ${err}`),
    onCompleted: data => setSmallLogoSrc(convertBase64ToObjectUrl(data.logo.content))
  });

  if (loading) return null;
  return <RocketFavIcon favIconSource={smallLogoSrc} defaultFavIcon={favIcon} />;
};

export default FavIcon;
